<div id="body"
     class="flex-box">
    <!-- loading image -->
    <div class="page-content">
        <div class="page-box-1">
            <h1 class="heading-1">{{h1Text}}</h1>
            <div *ngIf="!contentLoaded">
                <span>Unsubscribing...</span>
                <br>
                <br>
                <app-wrench-spinner diameter="125"></app-wrench-spinner>
            </div>
            <p class="text-large">{{pText}}</p>
        </div>
    </div>
</div>
